<template>
    <div class="h-full w-full flex flex-col">
        <PostTrainingForm mode="edit" :selected-item="selectedItem" :entities="entities" @close="$emit('close')" @updated="onUpdated" />
    </div>
</template>

<script>
import PostTrainingForm from "./form.vue";
export default {
    name: "post-training-edit",
    emits: ["updated"],
    components: { PostTrainingForm, },
    props: ["selectedItem", "entities"],
    methods: {
        onUpdated(msg) {
            this.$emit('updated', msg);
        },
    },
}
</script>